import { render } from "./NewUser.vue?vue&type=template&id=6bf04c17&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=6bf04c17&scoped=true&lang=css"
import "./NewUser.vue?vue&type=style&index=1&id=6bf04c17&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf04c17"]])

export default __exports__